export default function (vm) {
  return [
    {
      title: "用户ID",
      key: "id",
      align: "center",
    },
    {
      title: "用户昵称",
      key: "nickName",
      align: "center",
    },
    {
      title: "手机号",
      key: "phone",
      align: "center",
    },
    {
      title: "注册时间",
      key: "createDt",
      align: "center",
    },
    {
      title: "最后登录",
      key: "lastTime",
      align: "center",
    },
    {
      title: "用户状态",
      key: "status",
      align: "center",
      render: (h, params) => {
        const status = params.row.status;
        const color = status === 1 ? "success" : "error";
        const text = status === 1 ? "正常" : "禁用";
        return h("Tag", { props: { color } }, text);
      },
    },
    {
      title: "操作",
      key: "action",
      width: 200,
      align: "center",
      render: (h, params) => {
        const row = params.row;
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "text",
                size: "small",
              },
              style: {
                color: "#3091FF",
              },
              on: {
                click: () => {
                  vm.showDetail(row);
                },
              },
            },
            "查看详情"
          ),
          h(
            "Button",
            {
              props: {
                type: "text",
                size: "small",
              },
              style: {
                color: "#3091FF",
              },
              on: {
                click: () => {
                  const newStatus = row.status === 1 ? 0 : 1;
                  vm.$Modal.confirm({
                    title: "确认操作",
                    content: `确定要${
                      newStatus === 1 ? "启用" : "禁用"
                    }该用户吗？`,
                    onOk: () => {
                      vm.handleStatusChange(row.id, newStatus);
                    },
                  });
                },
              },
            },
            row.status === 1 ? "禁用" : "启用"
          ),
          h(
            "Button",
            {
              props: {
                type: "text",
                size: "small",
              },
              style: {
                color: "#3091FF",
              },
              on: {
                click: () => {
                  vm.$Modal.confirm({
                    title: "确认删除",
                    content: "确定要删除该用户吗？",
                    onOk: () => {
                      vm.handleDelete(row.id);
                    },
                  });
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];
}
